const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const pageview = (url) => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && GA_MEASUREMENT_ID) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track funding scheme views
export const trackFundingView = (fundingId, fundingName) => {
  event({
    action: 'view_funding',
    category: 'Funding',
    label: fundingName,
    value: fundingId,
  });
};

// Track search usage
export const trackSearch = (searchTerm, resultsCount) => {
  event({
    action: 'search',
    category: 'Search',
    label: searchTerm,
    value: resultsCount,
  });
};

// Track filter usage
export const trackFilter = (filterType, filterValue) => {
  event({
    action: 'filter_used',
    category: 'Filters',
    label: `${filterType}: ${filterValue}`,
  });
};